import Script from "next/script"
import { getGlobals } from "storyblok/api"
import { getNewsItemPaths, getNewsArticle } from "storyblok/inTheNews"
import richText from "utilities/richText"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import ArticleSection from "components/Archive/ArticleSection"
import Meta from "components/Meta"
import { getExcerpt } from "utilities/getExcerpt"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function Article({ story }) {
  return (
    <>
      <Meta
        info={{
          title: `${story?.content?.name}`,
          og_title: `${story?.content?.name}`,
          twitter_title: `${story?.content?.name}`,
          description: `${getExcerpt(story?.content.content)}`,
          og_description: `${getExcerpt(story?.content.content)}`,
        }}
      />
      <StoryblokVisualEditor story={story?.content}>
        <main className="main-content" data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="7">
          <PageHeader
            blok={{
              type: "standard",
              heading: story?.content?.name,
              breadcrumbs: [{ text: "In the News", href: "/in-the-news" }, { text: story?.content?.name }],
            }}
          />
          <ArticleSection>{richText(story?.content?.content)}</ArticleSection>
        </main>
      </StoryblokVisualEditor>
      <Script type="application/ld+json" id="news-article-schema">
        {`{
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "headline": "${story?.content?.name}",
            "image": [
              "${story?.content?.image?.filename ?? ""}"
            ],
            "author": [{
              "@type": "Person",
              "name": "Mark Breyer",
              "url": "https://www.husbandandwifelawteam.com/team-members/mark-breyer"
            },{
              "@type": "Person",
              "name": "Alexis Breyer",
              "url": "https://www.husbandandwifelawteam.com/team-members/alexis-breyer"
            }]
        }`}
      </Script>
    </>
  )
}

export async function getStaticProps({ params: { slug }, preview = null }) {
  const globals = await getGlobals("exclude-global-sections")
  const story = await getNewsArticle(`in-the-news/${slug}`, preview)

  return {
    props: {
      story: story ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getNewsItemPaths(),
    fallback: false,
  }
}
